import KnifeMakerStore from '~src/types/types-store'
import { StepPath } from '~src/types/wizard'
import { Metal, Wood } from '~src/types/knife'

const knifeMakerDefaultState: KnifeMakerStore = {
  knivesSet: {
    pickedKnives: [],
    configuration: {
      blade: Metal.N690,
      handle: Wood.Olivewood,
      ferrules: Metal.Damasteel,
    },
  },
  wizard: {
    currentStepPath: StepPath.PickKnives,
    validSteps: [],
  },
  app: {
    language: 'PL',
  },
}

export default knifeMakerDefaultState
